const SCENE_CONTAINER = {
  POPUP: 'popup',
  WINDOW: 'window',
};

export default SCENE_CONTAINER;
